import styled from 'styled-components';

const Wrapper = styled.div`
    align-self: center;
    display: flex;
    flex-direction: row;
`;

export default Wrapper;
